import { render } from "./NULLpage.vue?vue&type=template&id=89abfe88"
const script = {}

import exportComponent from "E:\\gcm3\\demo\\codebasezoom\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__